import type { ComponentProps } from 'react'
import { DialogContent } from '@/components/ui/dialog'

/** Keep extraction wizards open until the user explicitly cancels or completes. */
export const preventExtractDialogOutsideDismiss: Pick<
  ComponentProps<typeof DialogContent>,
  'onInteractOutside' | 'onPointerDownOutside'
> = {
  onInteractOutside: (event) => {
    event.preventDefault()
  },
  onPointerDownOutside: (event) => {
    event.preventDefault()
  },
}
